import React from 'react';

const Twitter = (props) => (
	<svg
		viewBox="0 0 27 26"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M16.2957 10.7178L24.9156 0.706332L25.2713 0.293213H24.7261H22.6538H22.5391L22.4643 0.380092L15.0824 8.95359L9.20121 0.401554L9.12671 0.293213H8.99522H2H1.52466L1.79401 0.684873L10.8562 13.8625L1.81055 24.3678L1.45483 24.7809H2H4.07248H4.18713L4.26193 24.694L12.0693 15.6263L18.2906 24.6726L18.3651 24.7809H18.4965H25.4918H25.9671L25.6978 24.3892L16.2957 10.7178ZM19.6017 22.793L13.3922 13.9188V13.9183L13.3471 13.8537L12.4178 12.5257L5.29927 2.35203H7.87224L13.7644 10.7733L13.7645 10.7733L14.6937 12.1013L22.1747 22.793H19.6017Z"
			strokeWidth={0.5}
		/>
	</svg>
)

export default Twitter;
